export default __webpack_public_path__ + "static/media/coursera.b5f80b20.png";